import { Dumbbell, Zap, Video, Scan, Shield, TrendingUp, Mountain, Sparkles, Apple } from 'lucide-react';
import { STUDIO_IMAGE, IMAGES } from './constants';

export const services = [
  {
    id: "personal-training",
    title: "Personal Training",
    emoji: "💪",
    description: "Coaching fitness 100% individualisé pour atteindre vos objectifs spécifiques.",
    icon: Dumbbell,
    image: STUDIO_IMAGE,
    imagePosition: "center 30%",
    imageAlt: "Personal Training Nyon - Coach sportif privé Body-Up studio 150m²",
    imageAltEn: "Personal Training Nyon - Private fitness coach Body-Up 150m² studio",
    fullDescription: {
      intro: "Le Personal Training chez Body-Up, c'est bien plus qu'un simple entraînement. C'est une expérience de coaching 100% privée et personnalisée dans notre studio de 150m² entièrement équipé.",
      benefits: [
        "Programme sur mesure adapté à VOS objectifs",
        "Coaching 1:1 dans un espace 100% privé",
        "Suivi précis de votre progression",
        "Techniques d'entraînement professionnelles",
        "Motivation et accompagnement constant"
      ],
      forWho: "Que vous souhaitiez perdre du poids, prendre de la masse musculaire, améliorer votre condition physique ou vous préparer pour un événement sportif, nos coachs experts créent un programme adapté à vos besoins et votre emploi du temps.",
      badge: "🏆 N°1 à Nyon"
    }
  },
  {
    id: "online-coaching",
    title: "Coaching en ligne",
    emoji: "💻",
    description: "Accompagnement 100% personnalisé à distance via Zoom et suivi SMS pour atteindre vos objectifs où que vous soyez.",
    icon: Video,
    image: "https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?w=600&h=400&fit=crop",
    imagePosition: "center center",
    imageAlt: "Coaching en ligne Nyon - Personal training à distance via Zoom",
    imageAltEn: "Online coaching Nyon - Remote personal training via Zoom",
    isNew: true,
    fullDescription: {
      intro: "Le Coaching en ligne Body-Up vous permet de bénéficier de l'expertise de nos coachs où que vous soyez dans le monde. Des séances live via Zoom et un suivi quotidien par SMS pour un accompagnement structuré et personnalisé.",
      benefits: [
        "Séances live via Zoom avec votre coach",
        "Suivi quotidien personnalisé par SMS",
        "Programme sur mesure adapté à votre environnement",
        "Flexibilité totale : entraînez-vous quand vous voulez",
        "Accès à votre coach 7j/7"
      ],
      forWho: "Idéal pour les expatriés, les voyageurs fréquents, ou ceux qui préfèrent s'entraîner depuis chez eux avec un accompagnement professionnel de qualité.",
      badge: "💻 100% à distance"
    }
  },
  {
    id: "ems-training",
    title: "EMS Drysuit XBody",
    emoji: "⚡",
    description: "Technologie XBody Drysuit sans fil. Séances courtes et très intenses (20-25 min) — en solo ou duo avec Laurent au studio de Nyon, ou en petits groupes sur notre plateforme dédiée.",
    icon: Zap,
    image: IMAGES.ems,
    imagePosition: "center 20%",
    imageAlt: "EMS Drysuit XBody sans fil - Technologie derniere generation Body-Up Nyon",
    imageAltEn: "EMS Drysuit XBody wireless - Latest generation technology Body-Up Nyon",
    fullDescription: {
      intro: "La technologie XBody Drysuit represente la 3e generation d'electrostimulation musculaire. Creee par XBody, leader mondial de l'EMS, cette combinaison seche 100% sans fil s'installe en 30 secondes. Chez Body-Up, elle est disponible sous 3 formats : SOLO avec Laurent, DUO (2 personnes) au studio de Nyon, ou en PETITS GROUPES (max 3) sur notre plateforme dediee body-up-ems.ch.",
      benefits: [
        "20 min EMS = stimulation intense de tout le corps",
        "Solo, Duo ou Petits Groupes (3 max) selon vos preferences",
        "Coaching personnel avec Laurent en solo/duo au studio Nyon",
        "Technologie XBody - Leader mondial de l'EMS",
        "Combinaison Drysuit 3e generation, 100% sans fil",
        "Installation ultra-rapide en 30 secondes",
        "Electrodes integrees aux epaules, bras, abdominaux, fessiers et cuisses",
        "Sans impact sur les articulations",
        "Scan 3D Styku disponible en complement"
      ],
      forWho: "Parfait pour les professionnels actifs, les personnes en reeducation ou ceux qui cherchent une alternative ultra-efficace. En SOLO avec Laurent pour un accompagnement 1:1 dans le studio Nyon, en DUO pour partager la seance avec votre partenaire ou un ami, ou en PETITS GROUPES pour une ambiance collective sur notre autre plateforme.",
      badge: "⚡ XBody Drysuit - 3e Generation",
      groupBadge: {
        text: "Ou EMS en petits groupes (3 max)",
        url: "https://www.body-up-ems.ch",
        description: "Decouvrez notre plateforme dediee a l'EMS Drysuit XBody en petits groupes sur body-up-ems.ch !"
      }
    }
  },
  {
    id: "3d-scanner",
    title: "Scanner 3D Styku",
    emoji: "📊",
    description: "Analyse précise de votre composition corporelle pour des stratégies fitness personnalisées.",
    icon: Scan,
    image: IMAGES.scan3d,
    imagePosition: "center center",
    imageAlt: "Scanner 3D Styku Nyon - Analyse composition corporelle Body-Up",
    imageAltEn: "3D Styku Scanner Nyon - Body composition analysis Body-Up",
    fullDescription: {
      intro: "Le Scanner 3D Styku est une technologie de pointe qui crée un modèle 3D complet de votre corps en quelques secondes, offrant des données précises sur votre composition corporelle.",
      benefits: [
        "Analyse de composition corporelle ultra-précise",
        "Suivi de vos mensurations en temps réel",
        "Visualisation 3D de votre corps",
        "Définition d'objectifs réalistes et mesurables",
        "Comparaison avant/après motivante"
      ],
      forWho: "Indispensable pour tous ceux qui veulent suivre leur transformation avec précision et ajuster leur programme en fonction de données concrètes.",
      badge: "🎯 Précision scientifique"
    }
  },
  {
    id: "boxing",
    title: "Initiation Boxe",
    emoji: "🥊",
    description: "Apprenez les fondamentaux de la boxe, améliorez votre condition physique et votre coordination.",
    icon: Shield,
    image: IMAGES.boxing,
    imagePosition: "center 25%",
    imageAlt: "Initiation boxe Nyon - Fitness boxing coach privé Body-Up",
    imageAltEn: "Boxing introduction Nyon - Fitness boxing private coach Body-Up",
    fullDescription: {
      intro: "Découvrez l'art noble de la boxe dans un cadre privé et bienveillant. Nos séances d'initiation vous permettent d'apprendre les techniques fondamentales tout en vous défoulant.",
      benefits: [
        "Cardio intense et brûlage de calories maximal",
        "Amélioration de la coordination et des réflexes",
        "Renforcement musculaire complet",
        "Évacuation du stress et confiance en soi",
        "Apprentissage dans un cadre sécurisé"
      ],
      forWho: "Ouvert à tous les niveaux, de la découverte à la préparation de combats amateurs. Aucune expérience préalable requise !",
      badge: "🥊 Défoulez-vous !"
    }
  },
  {
    id: "power-plate",
    title: "Power Plate",
    emoji: "🔄",
    description: "Entraînements complets accélérés utilisant la technologie de vibration pour des résultats rapides.",
    icon: TrendingUp,
    image: "https://customer-assets.emergentagent.com/job_code-loader-4/artifacts/ekv4u4tg_Power-Plate-Training-coaching-sportif-Nyon.webp",
    imagePosition: "center 15%",
    imageAlt: "Power Plate Nyon - Entraînement vibrations Body-Up",
    imageAltEn: "Power Plate Nyon - Vibration training Body-Up",
    fullDescription: {
      intro: "Le Power Plate utilise des vibrations triplanaires pour activer vos muscles de manière réflexe, rendant chaque exercice jusqu'à 3x plus efficace.",
      benefits: [
        "Activation musculaire jusqu'à 97% des fibres",
        "Amélioration de la circulation sanguine",
        "Renforcement musculaire en profondeur",
        "Réduction de la cellulite",
        "Gain de souplesse et d'équilibre"
      ],
      forWho: "Idéal en complément d'un programme de personal training ou pour ceux qui recherchent une récupération active et un travail musculaire profond.",
      badge: "🔄 Vibrations efficaces"
    }
  },
  {
    id: "hypoxico",
    title: "Hypoxico",
    emoji: "🏔️",
    description: "Entraînement en simulation d'altitude pour améliorer vos performances cardiovasculaires.",
    icon: Mountain,
    image: IMAGES.hypoxie,
    imagePosition: "center 30%",
    imageAlt: "Hypoxico Nyon - Entraînement altitude hypoxie Body-Up",
    imageAltEn: "Hypoxico Nyon - Altitude hypoxic training Body-Up",
    fullDescription: {
      intro: "L'Hypoxico simule les conditions d'altitude (jusqu'à 6400m) pour entraîner votre corps à optimiser l'utilisation de l'oxygène - la même technologie utilisée par les athlètes olympiques.",
      benefits: [
        "Amélioration de l'endurance et du VO2max",
        "Accélération du métabolisme",
        "Production accrue de globules rouges",
        "Préparation à l'altitude pour les sports de montagne",
        "Récupération active optimisée"
      ],
      forWho: "Parfait pour les sportifs d'endurance, les amateurs de sports de montagne ou ceux qui cherchent à booster leur métabolisme naturellement.",
      badge: "🏔️ Entraînement altitude"
    }
  },
  {
    id: "fitsonic",
    title: "Fitsonic",
    emoji: "✨",
    description: "Traitement innovant combinant fitness et technologie pour la réduction de la cellulite.",
    icon: Sparkles,
    image: IMAGES.fitsonic,
    imagePosition: "center 40%",
    imageAlt: "Fitsonic Nyon - Traitement anti-cellulite Body-Up",
    imageAltEn: "Fitsonic Nyon - Anti-cellulite treatment Body-Up",
    fullDescription: {
      intro: "Le Fitsonic combine ultrasons, infrarouge et drainage pour cibler efficacement la cellulite et raffermir votre silhouette.",
      benefits: [
        "Réduction visible de la cellulite",
        "Raffermissement de la peau",
        "Stimulation du drainage lymphatique",
        "Amélioration de la circulation",
        "Résultats visibles après quelques séances"
      ],
      forWho: "Idéal pour ceux qui souhaitent affiner leur silhouette et combattre la cellulite de manière non-invasive, en complément d'un programme sportif.",
      badge: "✨ Anti-cellulite"
    }
  },
  {
    id: "nutrition",
    title: "Plan Alimentaire",
    emoji: "🥗",
    description: "Conseils nutritionnels personnalisés pour compléter votre parcours fitness.",
    icon: Apple,
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=600&h=400&fit=crop",
    imagePosition: "center center",
    imageAlt: "Plan alimentaire Nyon - Nutrition coaching sportif Body-Up",
    imageAltEn: "Meal plan Nyon - Sports nutrition coaching Body-Up",
    fullDescription: {
      intro: "La nutrition est un levier majeur de vos résultats. Nos plans alimentaires personnalisés sont conçus pour compléter parfaitement votre programme d'entraînement.",
      benefits: [
        "Analyse de vos habitudes alimentaires actuelles",
        "Plan nutritionnel adapté à vos objectifs",
        "Recettes simples et délicieuses",
        "Suivi et ajustements réguliers",
        "Conseils pratiques pour le quotidien"
      ],
      forWho: "Essentiel pour quiconque veut maximiser ses résultats, que ce soit pour perdre du poids, prendre de la masse ou améliorer sa santé globale.",
      badge: "🥗 Levier majeur des résultats"
    }
  }
];

